import React from "react";
import { Navigate, Params } from "react-router-dom";
import { inject, observer } from "mobx-react";
import ServiceStore from "./ServiceStore";
import { UtilityMethods, withRouter } from "@mindmemobile/mm-shared-global";
import { UpsertServiceActiveStep } from "./Service.enum";
interface IProps {
  serviceStore?: ServiceStore;
  children: React.ReactElement;
  currentRoute: string;
  params: Readonly<Params<string>>;
}

const ProtectedRoute: React.FC<IProps> = ({
  children,
  currentRoute,
  serviceStore,
  params,
}) => {
  let isValid = false;
  const serviceId = () => {
    const split = ((params && params["*"]) || "").split("/");
    const id = split[split.length - 1];
    if (UtilityMethods.isValidObjectId(id)) {
      return id;
    }
    return null;
  };

  switch (serviceStore?.activeStep) {
    case UpsertServiceActiveStep.Detail:
      isValid = currentRoute === "detail";
      break;
    case UpsertServiceActiveStep.Pricing:
      isValid = currentRoute === "pricing";
      break;
    case UpsertServiceActiveStep.Options:
      isValid = currentRoute === "options";
      break;
  }

  const queryParam: string = serviceId() ? `/${serviceId()}` : "";
  return isValid ? (
    children
  ) : (
    <Navigate to={`/app/service/detail${queryParam}`} />
  );
};

export default inject("serviceStore")(withRouter(observer(ProtectedRoute)));
